import * as React from "react";
import IndexPolizaEndorsements from "../polizaEndorsements/IndexPolizaEndorsements";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

var ListPolizaEndorsementsApp = function ListPolizaEndorsementsApp(props) {
  var queryClient = new QueryClient();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(QueryClientProvider, {
    client: queryClient
  }, /*#__PURE__*/React.createElement(IndexPolizaEndorsements, props)));
};

export default ListPolizaEndorsementsApp;